import { RefObject, useEffect, useState } from 'react';

import { ChartSize } from '../../types/chart-renderer-props';

export const useChartSize = (containerRef: RefObject<HTMLElement | null>, minHeight: number): ChartSize => {
    const [size, setSize] = useState<ChartSize>({ width: 0, height: minHeight });

    useEffect(() => {
        const element = containerRef.current;
        if (!element) {
            return;
        }

        const updateSize = () => {
            const rect = element.getBoundingClientRect();
            const width = rect.width;
            // Prefer the container's laid-out height, but never grow from chart paint
            // (Apex heatmaps can expand the box and feedback through ResizeObserver).
            const laidOutHeight = element.clientHeight;
            setSize({
                width,
                height: Math.max(laidOutHeight > 0 ? Math.floor(laidOutHeight) : minHeight, minHeight)
            });
        };

        updateSize();

        const observer = new ResizeObserver(updateSize);
        observer.observe(element);

        return () => observer.disconnect();
    }, [containerRef, minHeight]);

    return size;
};
